import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import React from "react";
import { useLoaderData } from "react-router";
import { formatLongDate } from "utilities";
import { getMapFilterValuesToInstructionFn, mapResponseToFilterValues } from "./helpers";
import { formatMoneyDto } from "utilities/formatter";
import SubLabel from "components/Atoms/Sublabel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { findEnumLabel } from "utilities/enumutils";
import { useClientId } from "common/SessionContext";
import { CreditBalancePanel } from "credits/CreditBalancePanelApp";

const CreditTransactionListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.CreditTransactionListFrontModel>();
  const clientId = useClientId();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={RESX.Credit.CreditTransactionHistory}
        filterSet="creditTransaction_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={instr => window.CoreApi.Credit.ListCreditTransaction({ ...instr, clientId })}
        getId={item => item.creditTransactionId}
        layout={{
          type: "table",
          columns: [{
            key: "date",
            header: RESX.DateTime.lblDate,
            render: item => formatLongDate(item.createdUtc)
          }, {
            key: "service",
            header: RESX.Service.resxService,
            render: item => <div>
              <div>{findEnumLabel(item.referenceType, serverReference.creditTransactionReferenceTypes)}</div>
              <div>{item.description}</div>
              <SubLabel>{item.actorName}</SubLabel>
            </div>
          }, {
            key: "credits",
            header: "Credits",
            className: "s1_cell_financialamount",
            render: item => formatMoneyDto({ money: item.amount, displayCents: true })
          }]
        }}
        filters={<KeywordFilter placeholder={RESX.GeneralLabels.Search} />}
        renderExtraFilters={() => <CreditBalancePanel panelType="s1_panel" style={{ flex: "0 0 500px" }} />}
        functions={{
          mapFilterValuesToInstruction: getMapFilterValuesToInstructionFn(clientId),
          mapResponseToFilterValues
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>
};

export default CreditTransactionListApp;
